export default "__VITE_ASSET__n6EBUHCE__"